import { Fragment } from "react";
import { Provider } from "react-redux";
import NavBar from "./components/NavBar";
import Home from "./pages/Home";
import store from './redux/store';

const App = () => {
  return (
    <Provider store={store}>
      <Fragment>
        <NavBar />
        <Home />
      </Fragment>
    </Provider>
  );
};

export default App;
